import React, { useState, useEffect } from 'react'
import { MWLSlidingPane } from 'react-web-white-label'
import './DpsSidePanel.css'

const DpsSidePanel = ({
  panStatus,
  onClose,
  SliderComponent,
  onRequestClose,
  sliderHeader,
  direction,
  width,
}) => {
  const [panelWidth, setPanelWidth] = useState('1200px')

  useEffect(() => {
    const calculateResponsiveWidth = () => {
      const viewportWidth = window.innerWidth
      // Figma spec: 1200px for 1920px resolution (62.5% ratio)
      const responsiveWidth = Math.round((viewportWidth * 62.5) / 100)
      // Cap maximum at 1200px and minimum at 400px
      const finalWidth = Math.min(Math.max(responsiveWidth, 400), 1200)
      setPanelWidth(`${finalWidth}px`)
    }

    calculateResponsiveWidth()
    window.addEventListener('resize', calculateResponsiveWidth)
    return () => window.removeEventListener('resize', calculateResponsiveWidth)
  }, [])

  return (
    <div className="dps-side-panel">
      <MWLSlidingPane
        panStatus={panStatus}
        onClose={onClose ?? (() => {})}
        onRequestClose={onRequestClose ?? (() => {})}
        width={panelWidth}
        SliderComponent={SliderComponent}
        sliderHeader={sliderHeader}
        direction={direction}
      />
    </div>
  )
}

export default DpsSidePanel
